import plusIcon from "../assets/svg/plus-table.svg";
import IconLogoPerson2 from "../assets/svg/IconLogoPerson2.svg";
import IconLogoBank from "../assets/svg/IconLogoBank.svg";
import IconLogoCashier from "../assets/svg/IconLogoCashier.svg";
import IconLogoFund from "../assets/svg/IconLogoFund.svg";
import IconLogoCheque from "../assets/svg/IconLogoCheque.svg";
import IconLogoAccount from "../assets/svg/IconLogoAccount.svg";
import { apiDeleteTransactions, apiGetTransactions, apiGetTransactionsExcel } from "../api/transactionApi";
import { apiGetProjects } from "../api/projectApi";
import { apiGetBranches } from "../api/branchApi";
import { openFactorDrawer, openTransactionDrawer } from "helpers/DrawerActions";
import { formatPrice } from "../helpers";
import getCurrency from "helpers/currencyHelper";
import { searchType } from "./FactorForm";

const defaultTableColumns = [
    {
        name: "کد حسابداری",
        key: "accountingCode",
        filterParams: {
            column: "accountingCode",
            columnType: "string",
        },
    },
    {
        name: "مبلغ",
        key: "amount",
        filterParams: {
            subColumn: "amount",
            columnType: "number",
        },
        getValue: (item) => `${formatPrice(item?.amount || 0)} ${item?.Currency?.en_title || getCurrency().defCur.en_title}`,
        searchType: "quantitative",
    },
    {
        name: "شرح",
        key: "description",
        filterParams: {
            column: "description",
            columnType: "string",
        },
        clickable: (item) => item.FactorId,
        onClick: (dispatch, item) => {
            if (item.FactorId) {
                openFactorDrawer(dispatch, {id: item.FactorId});
            }
        },
    },
    {
        name: "تاریخ",
        key: "date",
        filterParams: {
            column: "date",
            columnType: "date",
        },
        searchType: "date",
    },
    {
        name: "پروژه",
        key: "Project",
        searchKey: "title",
        getValue: (item) => {
          return item.Project?.title ?? "-";
        },
        filterParams: {
          column: "ProjectId",
          columnType: "string",
          relationModelName: "Project",
          relationColumn: "title",
        },
        searchType: searchType.autocomplete,
        dataKey: {
          column: "projects",
          key: "title",
        },
      },
      {
        name: "شعبه",
        key: "Branch",
        searchKey: "title",
        getValue: (item) => {
          return item.Branch?.title ?? "-";
        },
        filterParams: {
          column: "BranchId",
          columnType: "string",
          relationModelName: "Branch",
          relationColumn: "title",
        },
        searchType: "autocomplete",
        dataKey: {
          column: "branches",
          key: "title",
        },
      },
];

export const transactionIndexData = [
    {
        title: "دریافت",
        description: "",
        key: "receive",
        label: "دریافت",
        pluralLabel: "دریافت ها",
        pageTitle: "دریافت ها",
        pageDescription: "لیست دریافت های کسب و کار",
        tableColumns: defaultTableColumns,
        disableDateFilter: true,
        actions: {
            view: {
                label: "مشاهده تراکنش",
                openDrawer: openTransactionDrawer,
            },
            add: {
                title: "ثبت",
                icon: plusIcon,
                url: "/transactions/add",
            },
            edit: {},
            fetch: apiGetTransactions,
            delete: apiDeleteTransactions,
            copy: true,
            excel: {
                export: apiGetTransactionsExcel,
            },
            sort: {
                model: "Transaction",
            },
            archive: {
                model: 'transaction'
            }
        },
    },
    {
        title: "پرداخت",
        description: "",
        key: "payment",
        label: "پرداخت",
        pluralLabel: "پرداخت ها",
        pageTitle: "پرداخت ها",
        pageDescription: "لیست پرداخت های کسب و کار",
        tableColumns: defaultTableColumns,
        disableDateFilter: true,
        actions: {
            view: {
                label: "مشاهده تراکنش",
                openDrawer: openTransactionDrawer,
            },
            add: {
                title: "ثبت",
                icon: plusIcon,
                url: "/transactions/add",
            },
            edit: {},
            fetch: apiGetTransactions,
            delete: apiDeleteTransactions,
            copy: true,
            excel: {
                export: apiGetTransactionsExcel,
            },
            sort: {
                model: "Transaction",
            },
            archive: {
                model: 'transaction'
            }
        },
    },
    {
        title: "درآمد",
        description: "",
        key: "income",
        label: "درآمد",
        pluralLabel: "درآمدها",
        pageTitle: "درآمد ها",
        pageDescription: "لیست درآمدهای کسب و کار",
        tableColumns: defaultTableColumns,
        disableDateFilter: true,
        actions: {
            view: {
                label: "مشاهده تراکنش",
                openDrawer: openTransactionDrawer,
            },
            add: {
                title: "ثبت",
                icon: plusIcon,
                url: "/transactions/add",
            },
            edit: {},
            fetch: apiGetTransactions,
            delete: apiDeleteTransactions,
            copy: true,
            excel: {
                export: apiGetTransactionsExcel,
            },
            sort: {
                model: "Transaction",
            },
            archive: {
                model: 'transaction'
            }
        },
    },
    {
        title: "هزینه",
        description: "",
        key: "cost",
        label: "هزینه",
        pluralLabel: "هزینه ها",
        pageTitle: "هزینه ها",
        pageDescription: "لیست هزینه های کسب و کار",
        tableColumns: defaultTableColumns,
        disableDateFilter: true,
        actions: {
            view: {
                label: "مشاهده تراکنش",
                openDrawer: openTransactionDrawer,
            },
            add: {
                title: "ثبت",
                icon: plusIcon,
                url: "/transactions/add",
            },
            edit: {},
            fetch: apiGetTransactions,
            delete: apiDeleteTransactions,
            copy: true,
            excel: {
                export: apiGetTransactionsExcel,
            },
            sort: {
                model: "Transaction",
            },
            archive: {
                model: 'transaction'
            }
        },
    },
];

export const transactionFormData = {
    transaction: {
        title: "تراکنش",
        navigation: {
            title: "ثبت تراکنش",
            // description: 'ثبت اطلاعات شخص',
            backTitle: "بازگشت",
            backUrl: "/transactions",
        },
        tabs: [
            {
                key: "receive",
                name: "دریافت",
            },
            {
                key: "payment",
                name: "پرداخت",
            },
            {
                key: "income",
                name: "درآمد",
            },
            {
                key: "cost",
                name: "هزینه",
            },
        ],
        receive: {
            key: "receive",
            name: "دریافت",
            sourceName: "پرداخت",
            destinationName: "دریافت",
            hasFactor: true,
            factorTypes: '["sale", "buyReturn"]',
            sourceOptions: [
                {
                    formType: "transaction",
                    key: "person",
                    index: 0,
                    title: "شخص",
                    logo: IconLogoPerson2,
                    options: "customers",
                },
            ],
            destinationOptions: [
                {formType: "transaction", key: "person", title: "شخص", logo: IconLogoPerson2, options: "customers"},
                {formType: "transaction", key: "bank", title: "بانک", logo: IconLogoBank, options: "banks"},
                {
                    formType: "transaction",
                    key: "cashier",
                    title: "صندوق",
                    logo: IconLogoCashier,
                    options: "cashiers",
                },
                {formType: "transaction", key: "fund", title: "تنخواه گردان", logo: IconLogoFund, options: "funds"},
                {formType: "transaction", key: "cheque", title: "چک", logo: IconLogoCheque, options: "customers"},
                // {formType: "transaction", key: "account", title: "حساب", logo: IconLogoAccount, options: 'accounts'},
            ],
            inputs: [
                {
                    formType: "transaction",
                    outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left",
                    wrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 px-1",
                    active: true,
                    type: "accountingCode",
                    name: "accountingCode",
                    label: "کد حسابداری",
                    maxLength: 20,
                    options: [
                        {
                            label: "اتوماتیک",
                            value: true,
                        },
                        {
                            label: "دستی",
                            value: false,
                        },
                    ],
                },
                {
                    formType: "transaction",
                    outerWrapperClass:
                        "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                    name: "description",
                    label: "شرح",
                    maxLength: 255,
                },
                {
                    formType: "transaction",
                    outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left",
                    type: "selectBox",
                    addModal: {
                        props: {
                            component: "branch",
                            title: "افزودن شعبه",
                            closeButton: true,
                            onFinish: (token) => apiGetBranches(token),
                        },
                    },
                    name: "Branch",
                    label: "شعبه",
                    showInput: true,
                    options: "branches",
                },
                {
                    formType: "transaction",
                    outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left",
                    type: "selectBox",
                    addModal: {
                        props: {
                            component: "project",
                            title: "افزودن پروژه",
                            closeButton: true,
                            onFinish: (token) => apiGetProjects(token),
                        },
                    },
                    name: "Project",
                    label: "پروژه",
                    showInput: true,
                    options: "projects",
                },
                {
                    formType: "transaction",
                    outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left",
                    type: "datePickerInput",
                    name: "date",
                    label: "تاریخ",
                    required: true,
                },
                {
                    formType: "transaction",
                    outerWrapperClass:
                        "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                    type: "currency",
                    name: "transaction",
                    label: "واحد پول",
                    maxLength: 16,
                    showInput: false,
                },
            ],
        },
        payment: {
            key: "payment",
            name: "پرداخت",
            sourceName: "دریافت",
            destinationName: "پرداخت",
            hasFactor: true,
            factorTypes: '["buy", "saleReturn"]',
            sourceOptions: [
                {
                    formType: "transaction",
                    key: "person",
                    index: 0,
                    title: "شخص",
                    logo: IconLogoPerson2,
                    options: "customers",
                },
            ],
            destinationOptions: [
                {formType: "transaction", key: "person", title: "شخص", logo: IconLogoPerson2, options: "customers"},
                {formType: "transaction", key: "bank", title: "بانک", logo: IconLogoBank, options: "banks"},
                {
                    formType: "transaction",
                    key: "cashier",
                    title: "صندوق",
                    logo: IconLogoCashier,
                    options: "cashiers",
                },
                {formType: "transaction", key: "fund", title: "تنخواه گردان", logo: IconLogoFund, options: "funds"},
                {formType: "transaction", key: "cheque", title: "چک", logo: IconLogoCheque, options: "banks"},
                {
                    formType: "transaction",
                    key: "spendCheque",
                    title: "خرج چک",
                    logo: IconLogoCheque,
                    options: "cheques",
                },
                // {formType: "transaction", key: "account", title: "حساب", logo: IconLogoAccount, options: 'accounts'},
            ],
            inputs: [
                {
                    formType: "transaction",
                    outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left",
                    wrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 px-1",
                    active: true,
                    type: "accountingCode",
                    name: "accountingCode",
                    label: "کد حسابداری",
                    maxLength: 20,
                    options: [
                        {
                            label: "اتوماتیک",
                            value: true,
                        },
                        {
                            label: "دستی",
                            value: false,
                        },
                    ],
                },
                {
                    formType: "transaction",
                    outerWrapperClass:
                        "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                    name: "description",
                    label: "شرح",
                    maxLength: 255,
                },
                {
                    formType: "transaction",
                    outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left",
                    type: "selectBox",
                    addModal: {
                        props: {
                            component: "branch",
                            title: "افزودن شعبه",
                            closeButton: true,
                            onFinish: (token) => apiGetBranches(token),
                        },
                    },
                    name: "Branch",
                    label: "شعبه",
                    showInput: true,
                    options: "branches",
                },
                {
                    formType: "transaction",
                    outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left",
                    type: "selectBox",
                    addModal: {
                        props: {
                            component: "project",
                            title: "افزودن پروژه",
                            closeButton: true,
                            onFinish: (token) => apiGetProjects(token),
                        },
                    },
                    name: "Project",
                    label: "پروژه",
                    showInput: true,
                    options: "projects",
                },
                {
                    formType: "transaction",
                    outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left",
                    type: "datePickerInput",
                    name: "date",
                    label: "تاریخ",
                    required: true,
                },
                {
                    formType: "transaction",
                    outerWrapperClass:
                        "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                    type: "currency",
                    name: "transaction",
                    label: "واحد پول",
                    maxLength: 16,
                    showInput: false,
                },
            ],
        },
        cost: {
            key: "cost",
            name: "هزینه",
            sourceName: "هزینه",
            destinationName: "پرداخت",
            hasFactor: false,
            sourceOptions: [
                {
                    formType: "transaction",
                    key: "account",
                    index: 0,
                    title: "حساب",
                    logo: IconLogoAccount,
                    options: "cost",
                    onlyLastChildSelectable: true,
                    editable: true,
                },
            ],
            destinationOptions: [
                {formType: "transaction", key: "person", title: "شخص", logo: IconLogoPerson2, options: "customers"},
                {formType: "transaction", key: "bank", title: "بانک", logo: IconLogoBank, options: "banks"},
                {
                    formType: "transaction",
                    key: "cashier",
                    title: "صندوق",
                    logo: IconLogoCashier,
                    options: "cashiers",
                },
                {formType: "transaction", key: "fund", title: "تنخواه گردان", logo: IconLogoFund, options: "funds"},
                {formType: "transaction", key: "cheque", title: "چک", logo: IconLogoCheque, options: "banks"},
                {
                    formType: "transaction",
                    key: "spendCheque",
                    title: "خرج چک",
                    logo: IconLogoCheque,
                    options: "cheques",
                },
                // {formType: "transaction", key: "account", title: "حساب", logo: IconLogoAccount, options: 'accounts'},
            ],
            inputs: [
                {
                    formType: "transaction",
                    outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left",
                    wrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 px-1",
                    active: true,
                    type: "accountingCode",
                    name: "accountingCode",
                    label: "کد حسابداری",
                    maxLength: 20,
                    options: [
                        {
                            label: "اتوماتیک",
                            value: true,
                        },
                        {
                            label: "دستی",
                            value: false,
                        },
                    ],
                },
                {
                    formType: "transaction",
                    outerWrapperClass:
                        "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                    name: "description",
                    label: "شرح",
                    maxLength: 255,
                },
                {
                    formType: "transaction",
                    outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left",
                    type: "selectBox",
                    addModal: {
                        props: {
                            component: "branch",
                            title: "افزودن شعبه",
                            closeButton: true,
                            onFinish: (token) => apiGetBranches(token),
                        },
                    },
                    name: "Branch",
                    label: "شعبه",
                    showInput: true,
                    options: "branches",
                },
                {
                    formType: "transaction",
                    outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left",
                    type: "selectBox",
                    addModal: {
                        props: {
                            component: "project",
                            title: "افزودن پروژه",
                            closeButton: true,
                            onFinish: (token) => apiGetProjects(token),
                        },
                    },
                    name: "Project",
                    label: "پروژه",
                    showInput: true,
                    options: "projects",
                },
                {
                    formType: "transaction",
                    outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left",
                    type: "datePickerInput",
                    name: "date",
                    label: "تاریخ",
                    required: true,
                },
                {
                    formType: "transaction",
                    outerWrapperClass:
                        "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                    type: "currency",
                    name: "transaction",
                    label: "واحد پول",
                    maxLength: 16,
                    showInput: false,
                },
            ],
        },
        income: {
            key: "income",
            name: "درآمد",
            sourceName: "درآمد",
            destinationName: "دریافت",
            hasFactor: false,
            sourceOptions: [
                {
                    formType: "transaction",
                    key: "account",
                    index: 0,
                    title: "حساب",
                    logo: IconLogoAccount,
                    options: "income",
                    onlyLastChildSelectable: true,
                    editable: true,
                },
            ],
            destinationOptions: [
                {
                    formType: "transaction",
                    key: "person",
                    index: 0,
                    title: "شخص",
                    logo: IconLogoPerson2,
                    options: "customers",
                },
                {formType: "transaction", key: "bank", title: "بانک", logo: IconLogoBank, options: "banks"},
                {
                    formType: "transaction",
                    key: "cashier",
                    title: "صندوق",
                    logo: IconLogoCashier,
                    options: "cashiers",
                },
                {formType: "transaction", key: "fund", title: "تنخواه گردان", logo: IconLogoFund, options: "funds"},
                {formType: "transaction", key: "cheque", title: "چک", logo: IconLogoCheque, options: "customers"},
                // {
                //     formType: "transaction",
                //     key: "spendCheque",
                //     title: "خرج چک",
                //     logo: IconLogoCheque,
                //     options: 'cheques'
                // },
                // {formType: "transaction", key: "account", title: "حساب", logo: IconLogoAccount, options: 'accounts'},
            ],
            inputs: [
                {
                    formType: "transaction",
                    outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left",
                    wrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 px-1",
                    active: true,
                    type: "accountingCode",
                    name: "accountingCode",
                    label: "کد حسابداری",
                    maxLength: 20,
                    options: [
                        {
                            label: "اتوماتیک",
                            value: true,
                        },
                        {
                            label: "دستی",
                            value: false,
                        },
                    ],
                },
                {
                    formType: "transaction",
                    outerWrapperClass:
                        "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                    name: "description",
                    label: "شرح",
                    maxLength: 255,
                },
                {
                    formType: "transaction",
                    outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left",
                    type: "selectBox",
                    addModal: {
                        props: {
                            component: "branch",
                            title: "افزودن شعبه",
                            closeButton: true,
                            onFinish: (token) => apiGetBranches(token),
                        },
                    },
                    name: "Branch",
                    label: "شعبه",
                    showInput: true,
                    options: "branches",
                },
                {
                    formType: "transaction",
                    outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left",
                    type: "selectBox",
                    addModal: {
                        props: {
                            component: "project",
                            title: "افزودن پروژه",
                            closeButton: true,
                            onFinish: (token) => apiGetProjects(token),
                        },
                    },
                    name: "Project",
                    label: "پروژه",
                    showInput: true,
                    options: "projects",
                },
                {
                    formType: "transaction",
                    outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left",
                    type: "datePickerInput",
                    name: "date",
                    label: "تاریخ",
                    required: true,
                },
                {
                    formType: "transaction",
                    outerWrapperClass:
                        "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                    type: "currency",
                    name: "transaction",
                    label: "واحد پول",
                    maxLength: 16,
                    showInput: false,
                },
            ],
        },
    },
};
